import React from "react";
import styles from "./styles/back-home-button.module.scss";
import backIcon from "@/assets/auth/left-arrow.svg";
import Image from "next/image";
import Link from "next/link";

const BackHomeButton = () => {
  return (
    <Link href={"/"}>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.back_icon}>
            <Image src={backIcon} alt="back" />
          </div>
          <div className={styles.text}>Back to home</div>
        </div>
      </div>
    </Link>
  );
};

export default BackHomeButton;
